import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=0b4534ae&scoped=true"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=0b4534ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4534ae",
  null
  
)

export default component.exports